import axios from '@utils/http'

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  getPermissions({ commit, dispatch, getters }, { queryTerms } = {}) {
    return axios
      .get('/api/permissions', { params: queryTerms })
      .then(response => {
        return response.data
      })
  },

  addPermission({ commit, state, rootState }, { permission } = {}) {
    return axios.post('/api/permissions', permission)
  },

  updatePermission({ commit, state, rootState }, { permission } = {}) {
    return axios.put(`/api/permissions/${permission.id}`, permission)
  },

  deletePermission({ commit, state, rootState }, { permission } = {}) {
    return axios.delete(`/api/permissions/${permission.id}`)
  },

  userRoleSearch({ commit, state, rootState }, { search } = {}) {
    return axios.get(`/api/permissions/userRoleSearch`, { params: { search } })
  },
}
